<template>
  <div>
    <div class="home">
      <div class="title">Welcome</div>
    </div>
    <div class="games">
      <GameComponent v-for="game in games" :key="game.id" :game="game"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import GameComponent from '@/components/GameComponent.vue'

export default {
  name: 'HomeComponent',
  components: {
    GameComponent
  },
  data () {
    return {
      games: [
        {
          id: 0,
          name: 'Hit The Duck',
          image: 'shot_it.jpg',
          description: 'Target Shooter',
          appStoreLink: 'https://apps.apple.com/us/app/hit-the-duck/id1156595685'
        },
        {
          id: 1,
          name: 'Galactos',
          image: 'galactos.png',
          description: 'Space Shooter',
          appStoreLink: 'https://apps.apple.com/is/app/galactos/id1612043741'
        }
      ]
    }
  }
}
</script>
<style scoped>
.home {
  margin-bottom: 50px;
}
.title {
  font-size: 60px;
  margin-top: 10px;
  color: #e6814b;
}
.games {
  /* margin: 0 auto; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}
@media screen and (max-width: 820px) {
  .games {
    flex-direction: column;
  }
}
</style>
